import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, DatePipe, NgIf, NgFor } from '@angular/common';
import {
  BehaviorSubject,
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  map,
  Observable,
  of,
  startWith,
  Subject,
  takeUntil,
  take,
} from 'rxjs';
import { ApiResponse } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { Branch } from 'src/app/models/interface/CAM/CompanyProfileInterface';
import { AccountService } from 'src/app/services/accountService/account.service';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { ContentService } from '../../services/content.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { SignUpContentServiceService } from 'src/app/modules/registration/services/sign-up-content-service.service';
import { jwtDecode } from 'jwt-decode';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { environment } from 'src/environments/environment';
import { AuthServiceService } from 'src/app/services/authService/auth-service.service';
import { PreviousPageCaptureService } from 'src/app/services/dataLayer/previous-page-capture.service';
import { MatTableDataSource } from '@angular/material/table';
import { NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective } from '@ng-select/ng-select';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { ExpiryDateComponent } from '../expiry-date/expiry-date.component';
import { DateOfBirthCalendarComponent } from '../../../registration/components/date-of-birth-calendar/date-of-birth-calendar.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DependentDatalayerService } from 'src/app/services/dataLayer/CAM/dependent.service';

export interface StateGroup {
  letter: string;
  names: {
    name: string;
    code: string;
    isdCode: string;
    countryFlag: string;
  }[];
}

@Component({
  selector: 'app-dependent-information-form',
  templateUrl: './dependent-information-form.component.html',
  styleUrls: ['./dependent-information-form.component.scss'],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    NgSelectComponent,
    AutoBlurSelectDirective,
    NgOptgroupTemplateDirective,
    NgOptionTemplateDirective,
    NgIf,
    NgLabelTemplateDirective,
    NgNotFoundTemplateDirective,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatSuffix,
    ExpiryDateComponent,
    DateOfBirthCalendarComponent,
    MatSelect,
    NgFor,
    MatOption,
    MatRadioGroup,
    MatRadioButton,
    MatSlideToggle,
    MatCheckbox,
    MatButton,
    MatProgressSpinner,
    DatePipe,
  ],
})
export class DependentInformationFormComponent implements OnInit, OnDestroy {
  public _siteCoreBaseUrl = environment.siteCoreBaseUrl;
  dependentForm!: FormGroup;
  editMode: boolean = false;
  newCustomCountries: any[] = [];
  countriesLists: any[] = [];
  filteredCountries: any;
  stateGroupOptions: Observable<StateGroup[]> = new BehaviorSubject<
    StateGroup[]
  >([]).asObservable();
  NationalityOptions: Observable<StateGroup[]> = new BehaviorSubject<
    StateGroup[]
  >([]).asObservable();
  PreviousCountryCode: any;
  elmVerified: boolean = false;
  selectedExpiryDate: Date | null = null;
  branchList: Branch[] = [];
  dependentFormTitle: string = 'Add New Dependent';
  CommonObj = {
    docType: '',
    docName: '',
  };
  relationshipList: string[] = ['Child', 'Spouse', 'Sibling', 'Parent'];
  isChildVisible: { [key: string]: boolean } = {
    isDOBCalendarVisible: false,
    isExpiaryCalendarVisible: false,
  };
  alfursantoggle: boolean = false;
  private readonly destroy$ = new Subject<void>();
  content: any;
  onBoardContent: any;
  dependentData: any;
  dependentId: string = '';
  travelerId: string = '';
  checkingELMAvailability: boolean = false;
  userId: any;
  dataSource1: any = new MatTableDataSource([]);
  titles: any[] = [];
  isLoadingSpinner: boolean = false;
  approveRejectAction: 'approve' | 'reject' | null = null;
  private readonly childTitles = ['miss', 'mstr'];

  get filteredTitles(): any[] {
    if (!this.shouldShowChildTitlesOnly()) {
      return this.titles || [];
    }
    return (this.titles || []).filter((t: any) => {
      const phrase = String(t?.Phrase || '').replace(/\./g, '').trim().toLowerCase();
      return this.childTitles.includes(phrase);
    });
  }

  private shouldShowChildTitlesOnly(): boolean {
    const relationship = this.dependentForm?.get('relationship')?.value;
    if (relationship !== 'Child') {
      return false;
    }
    return this.isUnderTwoYears(this.dependentForm?.get('dateOfBirth')?.value);
  }

  private isUnderTwoYears(dobValue: string | null | undefined): boolean {
    if (!dobValue || typeof dobValue !== 'string') {
      return false;
    }
    const [day, month, year] = dobValue.split('/').map(Number);
    if (!day || !month || !year) {
      return false;
    }
    const dob = new Date(year, month - 1, day);
    if (isNaN(dob.getTime())) {
      return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const secondBirthday = new Date(dob);
    secondBirthday.setFullYear(dob.getFullYear() + 2);
    return today < secondBirthday;
  }

  private clearTitleIfNotAllowedForChild(): void {
    if (!this.shouldShowChildTitlesOnly()) {
      return;
    }
    const currentTitle = this.dependentForm.get('title')?.value;
    const normalized = String(currentTitle || '').replace(/\./g, '').trim().toLowerCase();
    if (currentTitle && !this.childTitles.includes(normalized)) {
      this.dependentForm.get('title')?.patchValue(null);
    }
  }

  constructor(
    private readonly fb: FormBuilder,
    public _CommonService: CommonService,
    public _ApiService: ApiService,
    private readonly _AccountService: AccountService,
    private readonly _camService: CamService,
    private readonly _ToastrApiService: ToastrApiService,
    private readonly _Router: Router,
    private readonly contentService: ContentService,
    private readonly dictionaryContentService: DisctionaryContent,
    private readonly signUpContentService: SignUpContentServiceService,
    private readonly travelerManagement: TravelerManagement,
    private readonly _location: Location,
    private readonly route: ActivatedRoute,
    private readonly datePipe: DatePipe,
    private readonly authService: AuthServiceService,
    private readonly navService: PreviousPageCaptureService,
    private readonly _DependentDatalayer: DependentDatalayerService
  ) {
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      this.authService.getTokenbeforeLogin().subscribe((res: any) => {
        const tokenData = res.data;
        localStorage.setItem('token_type', tokenData.token_type);
        localStorage.setItem('access_token', tokenData.access_token);
        localStorage.setItem('expires_in', tokenData.expires_in);
        localStorage.setItem('session_id', tokenData.session_id);
        localStorage.setItem('scope', tokenData.scope);
      });
      const id = params['dependentId'];
      this.travelerId = '';
      this.travelerId = params['traveller'];
      this.userId = params['userId']
      if (id) {
        this.dependentId = id;
        setTimeout(() => {
          this.getDependentDetail(id);
        }, 1000);
      } else {
        return;
      }
    });


    this.dependentForm = this.fb.group({
      dependentId: [0],
      Nationality: [null],
      residence: [null],
      identityNumber: [
        null,
        [Validators.minLength(6), Validators.maxLength(10)],
      ],
      docExpiary: [null],
      issueCountry: [null,],
      dateOfBirth: [null, [Validators.required]],
      title: [null, [Validators.required]],
      firstname: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(50),
        ],
      ],
      middleName: [''],
      lastname: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(50),
        ],
      ],
      gender: ['Male'],
      email: [
        '',
        [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/), Validators.maxLength(200)],
      ],
      countryCode: [null],
      mobileNumber: [null,[Validators.minLength(8), Validators.maxLength(12)]],
      relationship: [null, [Validators.required]],
      alfursanOptIn: [],
      isAgreeTermsOfUse: [null, [Validators.required]],
      accessPersonalData: [null, [Validators.required]],
      accessOffersMarketingInfo: [],
      alfursanID: [''],
    });
    this.dependentForm.get('alfursanOptIn')?.valueChanges.subscribe((value: any) => {
      this.onToggleChange(value);
    })
    this.dependentForm
      .get('Nationality')
      ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        this.updateDocumentType(
          this.dependentForm.get('Nationality')?.value,
          this.dependentForm.get('residence')?.value
        );
        console.log('nationality changed ', this.dependentForm.get('Nationality')?.value);
        this.verifyELM('nn');
        this.validatePassportNumber();
      });

    this.dependentForm
      .get('residence')
      ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        this.updateDocumentType(
          this.dependentForm.get('Nationality')?.value,
          this.dependentForm.get('residence')?.value
        );
        console.log('residence changed ', this.dependentForm.get('residence')?.value);
        this.verifyELM('nn');
        this.validatePassportNumber();
      });
    this.dependentForm.get('title')?.valueChanges.subscribe((value: any) => {
      if (value == 'Ms' || value == 'Mrs' || value == 'Miss') {
        this.dependentForm.get('gender')?.patchValue('Female');
      } else {
        this.dependentForm.get('gender')?.patchValue('Male');
      }
    });

    this.dependentForm.get('relationship')?.valueChanges.subscribe(() => {
      this.clearTitleIfNotAllowedForChild();
    });

    this.dependentForm.get('dateOfBirth')?.valueChanges.subscribe(() => {
      this.clearTitleIfNotAllowedForChild();
    });
  }

  ngOnInit(): void {
    combineLatest({
      content: this.contentService.content$,
      dictionary: this.dictionaryContentService.content$,
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.content = {
          ...res.content,
          dictionary: res.dictionary,
        };
      });
    this.signUpContentService.content$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.onBoardContent = res;
        this.getSiteCoreArray('b2b.register.titledropdown')
      });
    this._ApiService
      .getCountriesData()
      .then(($res) => {
        this.newCustomCountries =
          this._CommonService.groupCountriesFilter($res);
        this.groupCountries($res);
      })
      .catch(($err) => { });

    this.dependentForm
      .get('Nationality')
      ?.valueChanges.pipe(
        startWith(''),
        map((value) => this.filterCountries(value))
      )
      .subscribe((filteredCountries) => {
        this.filteredCountries = filteredCountries;
        this.groupCountries(this.filteredCountries);
      });
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Removed the global valueChanges subscription to avoid clearing custom errors on checkbox toggle
    const dependentState = sessionStorage.getItem('dptState');
    if (dependentState == '1') {
      this.dependentFormTitle = 'Add New Dependent';
      this.dependentForm.enable();
    } else if (dependentState == '2') {
      this.dependentFormTitle = 'Dependent Details';
      this.dependentForm.disable();
    } else if (dependentState == '3') {
      if (this.dependentId && !sessionStorage.getItem('dptState') && !this.navService.getPreviousUrl) sessionStorage.setItem('dptState', '3');
      this.dependentFormTitle = 'Dependent Details Review';
      this.dependentForm.disable();
    } else if (dependentState == '4') {
      this.dependentFormTitle = 'Edit Dependent';
      this.dependentForm.enable();
    } else if (this.dependentId && !sessionStorage.getItem('dptState')) {
      this.dependentFormTitle = 'Dependent Details Review';
      this.dependentForm.disable();
    }

    this.dependentForm.get('identityNumber')?.valueChanges.subscribe((val: any) => {
      if (this.dependentForm.get('identityNumber')?.valid && this.CommonObj.docName != 'Passport') {
        this.verifyELM('nn');
      }
    });
    // this.dependentForm.get('countryCode')?.valueChanges.subscribe((data: any) => {
    //   if (data) {
    //     this.updatePhoneNumberValidators();
    //   } else {
    //     const phoneControl = this.dependentForm.get('mobileNumber');
    //     phoneControl?.setValidators(null);
    //     phoneControl?.updateValueAndValidity();
    //   }
    // })

    // GTM Event Call
    // const noOfResult = this.dataSource1?.data?.length || 0;
    // this.travelerManagement.traveler_dependents_detail_click('CTA',noOfResult,'View');
    this._DependentDatalayer.dependentDetails('pageview');
  }
  updatePhoneNumberValidators() {

    const phoneControl = this.dependentForm.get('mobileNumber');
    const selectedCountry = this.dependentForm.get('countryCode')?.value;
    const countryCode = selectedCountry;

    // Check if India (ISD code +91 or 91)
    const isIndia = countryCode === '+91' || countryCode === '91';

    if (isIndia) {
      // India: exactly 10 digits
      phoneControl?.setValidators([
        Validators.required,
        Validators.pattern(/^\d{10}$/),

      ]);
    } else {
      // Other countries: 6 to 12 digits
      phoneControl?.setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(12)
      ]);
    }

    phoneControl?.updateValueAndValidity();
  }
  getDependentDetail(id: any) {
    this.dependentId = id;
    const payload = {
      dependantId: id,
      b2bId: this.userId || localStorage.getItem('subAgentID'),
    }
    this._camService.getDependentDetails(payload).then((res: any) => {
      if (this.dependentFormTitle == 'Dependent Details Review' && res?.data[0]?.dependantdata[0]?.user_status != '4') {
        this._Router.navigateByUrl('/linkExpired', { replaceUrl: true })
      } else {
        this.dependentData = res?.data[0]?.dependantdata[0];
        this.patchAllValue(res?.data[0]?.dependantdata[0]);
      }
    }, (error: any) => {
      this._ToastrApiService.show('error', 'Something went wrong!');
    });
  }
  patchAllValue(data: any) {
    if (!data) return;
    const titlesList = Array.isArray(this.titles) ? this.titles : [];
    const matchedTitle = titlesList.find(
      (t: any) => t && t?.Phrase && data?.title && String(t.Phrase).replace(/\./g, '').trim().toLowerCase() === String(data.title).replace(/\./g, '').trim().toLowerCase()
    );
    this.dependentForm.patchValue({
      dependentId: data?.dependantId | 0,
      Nationality: data?.nationality || null,
      residence: data?.placeOfResidence || null,
      identityNumber: data?.documentNo || null,
      docExpiary: this.datePipe.transform(data?.documentExpiryDate, 'dd/MM/yyyy') || null,
      issueCountry: data?.documentIssuingCountry || null,
      dateOfBirth: this.datePipe.transform(data?.dob, 'dd/MM/yyyy') || null,
      title: matchedTitle?.Phrase || data?.title || null,
      firstname: data?.firstName || null,
      middleName: data?.middleName || null,
      lastname: data?.lastName || null,
      gender: data?.gender || '',
      email: data?.email || '',
      countryCode: data?.countryCode || null,
      mobileNumber: data?.phoneNo || null,
      relationship: data?.relation || null,
      alfursanOptIn: !!data?.alfursanId,
      accessOffersMarketingInfo: data?.accessOffersMarketingInfo,
      isAgreeTermsOfUse: data?.isAgreeTermsOfUse || null,
      accessPersonalData: data?.accessPersonalData || null,
      alfursanID: data?.alfursanId || ''
    });
    this.updateDocumentType(data?.nationality, data?.placeOfResidence);
    if (this.dependentForm.get('identityNumber')?.value) {
      this.dependentForm.get('identityNumber')?.markAsTouched();
    }
  }
  groupCountries(data: any): void {
    if (!this.countriesLists?.length) {
      this.countriesLists = data;
    }
    this.filteredCountries = data;
    const grouped: {
      [key: string]: {
        name: string;
        code: string;
        isdCode: string;
        countryFlag: string;
      }[];
    } = this.filteredCountries?.reduce(
      (acc: any, country: any) => {
        const firstLetter = (country?.countryName[0] || '').toUpperCase(); // Use countryName instead of Country
        if (!acc[firstLetter]) {
          acc[firstLetter] = [];
        }
        acc[firstLetter].push({
          name: country.countryName,
          code: country.isoCode,
          isdCode: country.code,
          countryFlag: country.newFlag.src,
        });
        return acc;
      },
      {} as {
        [key: string]: {
          name: string;
          code: string;
          isdCode: string;
          countryFlag: string;
        }[];
      }
    );
    if (this.filteredCountries) {
      const sortedGroupLetters = Object.keys(grouped).sort((a, b) =>
        a.localeCompare(b)
      );

      const saudiGroup = grouped['S']?.find((c) => c.name === 'Saudi Arabia');

      if (saudiGroup) {
        grouped['S'] = grouped['S'].filter((c) => c.name !== 'Saudi Arabia');
        grouped['S'] = [
          {
            name: 'Saudi Arabia',
            code: 'SA',
            isdCode: '+966',
            countryFlag:
              '/-/media/SaudiaWebApp/data/media/img/Flags/Latest-flags/Flag-saudi_arabia.ashx?rev=856c905ee3344e1295e5948ae4d64d9a',
          },
          ...grouped['S'],
        ];

        const index = sortedGroupLetters.indexOf('S');
        if (index > -1) {
          sortedGroupLetters.splice(index, 1);
        }
        sortedGroupLetters.unshift('S');
      }

      // Wrap the result in `of()` to make it an Observable
      this.stateGroupOptions = of(
        sortedGroupLetters.map((letter) => {
          return {
            letter: letter,
            names: grouped[letter],
          };
        })
      );
    }
  }

  filterCountries(value: any): void {
    const searchField =
      value?.stateGroup?.split('+')?.length === 1
        ? 'countryName'
        : 'code';

    const searchValue = (value?.stateGroup || '')
      .replace('+', '')
      .toLowerCase();

    const currentState: any[] = this.countriesLists?.filter(
      ($country: any) =>
        $country[searchField]
          ?.toString()
          .toLowerCase()
          .includes(searchValue)
    );

    this.groupCountries(currentState);

    if (currentState?.length < 2) {
      this.PreviousCountryCode = currentState;
    }
  }

  convertToISODate(dob: string): string {
    if (!dob) return '';

    // Split the date into day, month, and year
    const dateParts = dob.split('/');

    // If the format is correct, return the date in the desired format (YYYY-MM-DD)
    if (dateParts.length === 3) {
      const day = dateParts[0];
      const month = dateParts[1];
      const year = dateParts[2];

      // Ensure the month and day are zero-padded to 2 digits
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    return dob; // If the format is incorrect, return the original string
  }

  private buildELMPayload(): any {
    const dob = this.dependentForm.get('dateOfBirth')?.value;
    const identity = this.dependentForm.get('identityNumber')?.value;
    const nationality = this.dependentForm.get('Nationality')?.value;

    if (!dob || !identity) return null;

    const formattedDob = this.convertToISODate(dob);

    switch (this.CommonObj.docType) {
      case 'nationalID':
        return {
          nationalID: identity,
          nationality: nationality,
          dateOfBirth: formattedDob,
        };

      case 'iqama':
        return {
          iqama: identity,
          dateOfBirth: formattedDob,
        };

      default:
        return null; // passport → no ELM call
    }
  }

  verifyELM(_: any): void {
    if (this.CommonObj.docType === 'passport' || this.CommonObj.docType == '') {
      const state = sessionStorage.getItem('dptState')
      if (state == '2') {
        this.dependentForm.get('firstname')?.disable();
        this.dependentForm.get('lastname')?.disable();
      } else {
        this.dependentForm.get('firstname')?.enable();
        this.dependentForm.get('lastname')?.enable();
      }
      return;
    }
    this.dependentForm.get('firstname')?.disable();
    this.dependentForm.get('lastname')?.disable();

    const payload = this.buildELMPayload();
    if (!this.dependentForm.get('identityNumber')?.valid) {
      return;
    };
    if (!payload) return;
    this.checkingELMAvailability = true;
    this._AccountService.VerifyELMV1(payload).subscribe(
      (response) => {
        if (response?.data?.firstName) {
          this.dependentForm.patchValue({
            firstname: response.data.firstName ? response.data.firstName : '',
            lastname: response.data.lastName ? response.data.lastName : '',
          });
        }
        this.elmVerified = true;
        this.dependentForm.get('identityNumber')?.setErrors(null);
        this.checkingELMAvailability = false;
        this.dependentForm.updateValueAndValidity();
      },
      (error) => {
        const ctrl = this.dependentForm.get('identityNumber');
        ctrl?.setErrors({
          ...(ctrl?.errors || {}),
          elmError: true,
        });
        this.dependentForm.patchValue({
          firstname: '',
          lastname: '',
        });
        this.checkingELMAvailability = false;
        this.dependentForm.updateValueAndValidity();
        ctrl?.markAsTouched();
      }
    );
  }

  updateDocumentType(nationality: string, residence: string): void {
    console.log('nationality ', nationality);
    console.log('residence ', residence);
    // let docList = this.content?.['b2b.managetraveler.nationalid'].split('/');
    let docList = ('National ID/ IQAMA/ Passport').split('/');
    const identityCtrl = this.dependentForm.get('identityNumber');

    if (!nationality || !residence) {
      this.CommonObj = { docType: '', docName: '' };
      identityCtrl?.setValidators([Validators.minLength(6), Validators.maxLength(10)]);
      identityCtrl?.setErrors(null);
      identityCtrl?.updateValueAndValidity({ emitEvent: false });
      return;
    }

    if (nationality === 'SA' && residence === 'SA') {
      this.CommonObj = {
        docType: 'nationalID',
        docName: docList[0],
      };
    }

    if (nationality === 'SA' && residence !== 'SA') {
      this.CommonObj = {
        docType: 'nationalID',
        docName: docList[0],
      };
    }
    if (nationality !== 'SA' && residence === 'SA') {
      this.CommonObj = {
        docType: 'iqama',
        docName: docList[1].trim(),
      };
    }

    if (nationality !== 'SA' && residence !== 'SA') {
      this.CommonObj = {
        docType: 'passport',
        docName: docList[2].trim(),
      };
    }

    if (!identityCtrl) {
      return;
    }

    // Passport: same rules as new-traveler-form (required + 8–10 alphanumeric)
    if (this.CommonObj.docType === 'passport') {
      identityCtrl.setValidators([
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9]{6,12}$/),
      ]);
    } else {
      // National ID / Iqama — keep existing validators unchanged
      identityCtrl.setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(10),
        this.customPassportValidator.bind(this),
      ]);
    }
    identityCtrl.updateValueAndValidity({ emitEvent: false });
  }

  showComponent(componentKey: string, controlName?: string) {
    this.isChildVisible[componentKey] = true;
    for (const key in this.isChildVisible) {
      if (key !== componentKey) {
        this.isChildVisible[key] = false;
      }
    }
  }
  approvReject(status: string) {
    if (status == 'approve') {
      this.acceptDependent();
    } else {
      this.rejectDependent();
    }
  }
  acceptDependent() {
    //hit the event of on click of approve
    const noOfResult = 1;
    // this.travelerManagement.dependent_approval_click(noOfResult, 'Approve');
    this._DependentDatalayer.dependentReview('Requests received', 'Approve');
    this.isLoadingSpinner = true;
    this.approveRejectAction = 'approve';
    this._camService.dependentApproveAndReject('1', this.dependentId).then((res: any) => {
      this.isLoadingSpinner = false;
      this.approveRejectAction = null;
      this._ToastrApiService.show('success', `The dependent request for ${this.dependentForm?.get('firstname')?.value + ' ' + this.dependentForm?.get('lastname')?.value} is now approved.`);
      //hit the event of on success approve
      // this.travelerManagement.dependent_approve_status('Success');
      this._DependentDatalayer.dependentStatus('Dependent Details', 'Request status', 'Approve successful');
      this._Router.navigate(['/cam/family-member-management']);
    }, error => {
      this.isLoadingSpinner = false;
      this.approveRejectAction = null;
      this._ToastrApiService.show('error', 'Could not updated dependent.Something went wrong please try again!')
    });
  }
  rejectDependent() {
    //hit the event of on click of reject
    const noOfResult = 1;
    // this.travelerManagement.dependent_approval_click(noOfResult, 'Reject');
    this._DependentDatalayer.dependentReview('Requests received', 'Reject');
    this.isLoadingSpinner = true;
    this.approveRejectAction = 'reject';
    this._camService.dependentApproveAndReject('2', this.dependentId).then((res: any) => {
      this.isLoadingSpinner = false;
      this.approveRejectAction = null;
      this._ToastrApiService.show('error', `The dependent request for ${this.dependentForm?.get('firstname')?.value + ' ' + this.dependentForm?.get('lastname')?.value} is rejected.`);
      //hit the event of on success of reject
      //  this.travelerManagement.dependent_approve_status('Reject');
      this._DependentDatalayer.dependentStatus('Dependent Details', 'Request status', 'Reject successful');
      this._Router.navigate(['/cam/family-member-management']);
    }, error => {
      this.isLoadingSpinner = false;
      this.approveRejectAction = null;
      this._ToastrApiService.show('error', 'Could not updated dependent.Something went wrong please try again!')
    });
  }
  onDateSelected2(
    event: { type: string; date: Date | null },
    key: string
  ): void {
    if (event.type === 'dob') {
      if (
        !event.date ||
        event.date.toDateString() === new Date(0).toDateString()
      ) {
        return;
      }
      this.selectedExpiryDate = event.date ? new Date(event.date) : null;
      const formattedDate = this.getFormattedDate(this.selectedExpiryDate);
      this.dependentForm.get('docExpiary')?.setValue(formattedDate);
      this.isChildVisible[key] = false;
    }
  }
  getFormattedDate(date: Date | null): string | null {
    if (!date) return null;
    const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  onConfirm(componentKey: string) {
    this.verifyELM('nn');
    this.isChildVisible[componentKey] = false;
  }

  getImageUrl(path: string): string {
    if (!path) return '';

    const base = this._siteCoreBaseUrl?.replace(/\/+$/, '') || '';
    const cleanPath = path.replace(/^\/+/, '');

    return `${base}/${cleanPath}`;
  }

  onDateSelected(event: any): void {
    if (event.isCalenderShow === true) {
      const date = event.date ? new Date(event.date) : null; // Ensure date is valid or null
      const dobDateControl = this.dependentForm.get('dateOfBirth');

      if (date) {
        // Format the date and set it in the form control
        const formattedDate = this.getFormattedDate(date);

        dobDateControl?.setValue(formattedDate); // Update the form control value
        dobDateControl?.clearValidators(); // Clear validators for a valid date
      } else {
        // Handle the case when the date is null
        dobDateControl?.setValue(null);
      }
      // Update form control validation status
      dobDateControl?.updateValueAndValidity();
      // Hide the DOB calendar
      this.isChildVisible['isDOBCalendarVisible'] = false;
    }
    this.verifyELM('nn');
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: Event) {
    const target = event?.target as HTMLElement;
    const isDobInput = target.getAttribute('formControlName');
    if (!isDobInput) {
      this.isChildVisible['isDOBCalendarVisible'] = false;
      this.isChildVisible['isExpiaryCalendarVisible'] = false;
    }
  }

  getBranchInfoList() {
    this._camService
      .GetBranchInformation()
      .then((res: ApiResponse<Branch[]>) => {
        if (res?.status == 'Success') {
          this.branchList = res.data;
        } else {
          this.branchList = [];
        }
      })
      .catch((err: any) => {
        const errMsg =
          'Something went wrong while fetching Branch Information List.';
        this._ToastrApiService.show('error', errMsg);
        console.error('Error fetching branch information:', err);
        this.branchList = []; // Reset tableData on error
      })
      .finally(() => { });
  }


  onSubmit(formData: any) {
    this.isLoadingSpinner = true;
    if (this.dependentForm.invalid) {
      this.isLoadingSpinner = false;
      return;
    }
    const formValue = this.dependentForm.getRawValue();
    this.travelerManagement.add_dependents_details_cancel_click('Send invite');
    this._DependentDatalayer.newFamilyDependentCancelSaveEmployee('View sent invites', 'Send invite click', 'Send invite');
    this._DependentDatalayer.addNewDependentToggle('Send invite', 'Send invite');
    let payload = {
      b2bUserId: sessionStorage.getItem('userId'),
      companyId: localStorage.getItem('companyId') || 'Saa',
      dependantId: formValue?.dependentId,
      nationality: formValue?.Nationality,
      placeOfResidence: formValue?.residence,
      countryCode: formValue?.countryCode,
      title: formValue?.title,
      firstName: formValue?.firstname,
      middleName: formValue?.middleName,
      lastName: formValue?.lastname,
      relation: formValue?.relationship,
      email: formValue?.email,
      phoneNo: formValue?.mobileNumber,
      gender: formValue?.gender,
      documentNo: formValue?.identityNumber,
      dob: this._CommonService.formatDateToYMD(formValue?.dateOfBirth),
      alfursanId: formValue?.alfursanID,
      accessPersonalData: formValue?.accessPersonalData,
      accessOffersMarketingInfo: formValue?.accessOffersMarketingInfo,
      isAgreeTermsOfUse: formValue?.isAgreeTermsOfUse,
      documentIssuingCountry: formValue?.issueCountry,
      documentExpiryDate: this._CommonService.formatDateToYMD(formValue?.docExpiary)
    };
    this._camService
      .insertNewDependentV1(payload, (this.travelerId || '').toUpperCase())
      .then((res) => {
        if (!res) {
          this.isLoadingSpinner = false;
          this._ToastrApiService.show(
            'error',
            'No response received from server.'
          );
          return;
        }

        // Handle API response
        switch (res.status) {
          case 'Success':
            this.travelerManagement.dependent_invite_success('CTA', 'Success');

            if (this.dependentId) {
              this.travelerManagement.dependent_popup_click('Save');
            }
            if (this.dependentFormTitle == 'Add New Dependent') {
              this._ToastrApiService.show(
                'success',
                'Request has been successfully sent!'
              );
              this._DependentDatalayer.dependentRequestSuccess('Request has been successfully sent!', 'Invite sent', formValue?.relationship);
            } else {
              this._ToastrApiService.show(
                'success',
                'Profile has been updated successfully.'
              );
              this._DependentDatalayer.dependentRequestSuccess('Profile has been updated successfully.', 'Invite sent', formValue?.relationship);
            }
            this.isLoadingSpinner = false;
            this.goToBack();
            break;

          case 'Conflict':
            this.isLoadingSpinner = false;
            this._ToastrApiService.show(
              'warning',
              res.message || 'Duplicate entry detected.'
            );
            break;

          default:
            this.isLoadingSpinner = false;
            this._ToastrApiService.show(
              'error',
              res.message || 'Unexpected response from server.'
            );
            console.warn('Unhandled status:', res);
            break;
        }
      })
      .catch((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          'Something went wrong while saving the traveler. Please try again later.';

        this._ToastrApiService.show('error', errorMessage);
        this.isLoadingSpinner = false;
      });
  }

  onCancel() {
    //  this.travelerManagement.add_dependents_details_cancel_click( 'Send invite' );
    this._DependentDatalayer.addNewDependentToggle('Cancel', 'Cancel');
    this.travelerManagement.add_dependents_details_cancel_click('Cancel');
    this._DependentDatalayer.newFamilyDependentCancelSaveEmployee('View sent invites', 'Cancel click', 'Cancel');
    this.goToBack();
  }

  verifyDomainName() {
    const QlAccessToken: any = localStorage.getItem('QlAccessToken');
    const emailControl = this.dependentForm.get('email');
    if (!QlAccessToken || !emailControl?.value) return;
    const email: string = emailControl.value;
    const decoded: any = jwtDecode(QlAccessToken);
    if (decoded.hasDomain != 'false') {
      const afterAt = email.split('@')[1]; // part after @
      // 🔥 Compare domain
      if (afterAt.toLowerCase() !== decoded.domainName?.toLowerCase()) {
        // Set custom error
        emailControl.setErrors({
          ...(emailControl.errors || {}),
          domainMismatch: true,
        });
      } else {
        // Remove only domainMismatch error if exists
        if (emailControl.hasError('domainMismatch')) {
          const errors = { ...(emailControl.errors || {}) };
          delete errors['domainMismatch'];
          emailControl.setErrors(Object.keys(errors).length ? errors : null);
        }
      }
    }
  }

  getSiteCoreArray(keyString: string) {
    const data = this.onBoardContent?.[keyString];
    this.titles = Array.isArray(data) ? data : [];
    if (this.dependentData?.title) {
      const matchedTitle = this.titles.find(
        (t: any) => t && t?.Phrase && String(t.Phrase).replace(/\./g, '').trim().toLowerCase() === String(this.dependentData.title).replace(/\./g, '').trim().toLowerCase()
      );
      if (matchedTitle?.Phrase) {
        this.dependentForm.patchValue({ title: matchedTitle.Phrase });
      }
    }
  }
  goToBack() {
    if (window.history.length > 1) {
      this._location.back();
    } else {
      this._Router.navigate(['/cam/family-member-management']);
    }
  }
  onToggleChange(isChecked: boolean) {
    const alFursanControl = this.dependentForm.get('alfursanID');

    if (isChecked) {
      this.alfursantoggle = true;
      alFursanControl?.setValidators([Validators.required, alfursanValidator]);
      this._DependentDatalayer.addNewDependentToggle('alfursan_toggle_on', 'toggle');
    } else {
      this.alfursantoggle = false;
      alFursanControl?.clearValidators();
      this._DependentDatalayer.addNewDependentToggle('alfursan_toggle_off', 'toggle');
    }

    alFursanControl?.updateValueAndValidity();
  }

  callbyGtmTerms(event: MatCheckboxChange) {
    if (event.checked) {
      this._DependentDatalayer.addNewDependentToggle(
        'Terms_of_use_check',
        'check'
      );
    } else {
      this._DependentDatalayer.addNewDependentToggle(
        'Terms_of_use_uncheck',
        'uncheck'
      );
    }


  }

  callbyGtmPolicy(event: MatCheckboxChange) {
    if (event.checked) {
      this._DependentDatalayer.addNewDependentToggle(
        'Privacy_policy_check',
        'check'
      );
    } else {
      this._DependentDatalayer.addNewDependentToggle(
        'Privacy_policy_uncheck',
        'uncheck'
      );
    }
  }

  blockInvalidCharacters1(event: KeyboardEvent): void {
    const invalidChars = [
      '<',
      '>',
      '"',
      "'",
      '`',
      ';',
      ':',
      '$',
      '|',
      '[',
      ']',
      '~',
      '--',
      '&',
      '@',
      '\\',
      '?',
      '+',
      '_',
      '#',
      '%',
      '^',
      '*',
      '!',
      '=',
      '%',
      '(',
      ')',
      '{',
      '}',
      '/',
      '.',
      ','
    ];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  trimField(field: string) {
    const control = this.dependentForm.get(field);
    if (control?.value) {
      control.setValue(control.value.trim());
    }
  }

  customPassportValidator(control: AbstractControl): ValidationErrors | null {
    if (this.CommonObj?.docType !== 'passport') return null;
    const passportNumber = control.value;
    // ensure dependentForm is initialized
    if (!this.dependentForm) return null;
    const countryCode = this.dependentForm.get('Nationality')?.value;
    if (!passportNumber || !countryCode) return null;

    let isValid = true;
    switch (countryCode) {
      case 'IN':
        isValid = /^[A-Za-z]{1}[0-9]{7}$/.test(passportNumber);
        break;
      case 'SA':
        isValid = /^[A-Za-z]{1}[0-9]{7,9}$/.test(passportNumber);
        break;
      case 'UAE':
        isValid = /^[A-Za-z]{1}[0-9]{9}$/.test(passportNumber);
        break;
      case 'US':
        isValid = /^[a-zA-Z0-9]{9}$/.test(passportNumber);
        break;
      default:
        isValid = true;
    }

    if (!isValid) {
      return { invalidPassportNumber: true };
    }
    return null;
  }

  validatePassportNumber() {
    this.dependentForm.get('identityNumber')?.updateValueAndValidity();
  }

  get isSubmitDisabled(): boolean {
    const form = this.dependentForm;

    return (
      form.invalid ||
      !form.get('accessPersonalData')?.value ||
      !form.get('isAgreeTermsOfUse')?.value ||
      this.checkingELMAvailability ||
      !form.get('firstname')?.value?.trim() ||
      !form.get('lastname')?.value?.trim()
    );
  }
  ngOnDestroy() {
    this.editMode = false;
    this.destroy$.next();
    this.destroy$.complete();
    sessionStorage.removeItem('selectedTabName');
  }
}

export function alfursanValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  if (!value) return null;

  const isNumber = /^\d+$/.test(value);
  const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);

  if (isNumber) {
    return value.length === 10 ? null : { invalidNumberLength: true };
  }

  if (isEmail) {
    return value.length <= 200 ? null : { emailMaxLength: true };
  }

  return { pattern: true };
}
